import styled from 'styled-components'
import { white, grayLight } from '@bufferapp/ui/style/colors'

import { flexCol } from '~/shared/styles/layout'

export const Wrapper = styled.a`
  height: 100%;
  width: 100%;
  position: relative;
  cursor: pointer;
  text-decoration: none;
  user-select: none;
  display: block;
  background-color: ${grayLight};
  border-radius: 6px;
`

export const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'selected' does not exist on type 'Themed... Remove this comment to see the full error message
    props.selected ? '3px' : '6px'};
  user-select: none;
`

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5));
  border-radius: 6px;
  color: ${white};
  ${flexCol}
  justify-content: center;
  align-items: center;
  display: none;

  ${Wrapper}:hover & {
    display: flex;
  }
`

export const PlaceholderWrapper = styled.div`
  ${flexCol}
  justify-content: center;
  background-color: ${grayLight};
  color: ${white};
  width: 100%;
  height: 100%;
  border-radius: 6px;

  & > svg {
    width: 40%;
    height: 40%;
  }
`
